<template>
  <div>
    <div v-if="$store.state.user.clientID" :key="$root.time">
      <h1 class="main-heading">Financial</h1>
      <SectionNavigator
        :sections="$root.financial.sections"
        :schemas="$root.financial.schemas"
      />
      <router-view />
    </div>
  </div>
</template>

<script>
import SectionNavigator from '../SectionNavigator'

// import routes from '../../router/index'
export default {
  name: 'category-financial',
  props: { sections: String, schemas: Array },
  components: {
    SectionNavigator
  }
}
</script>
